import {
  AnnotationsTooltipConfig,
  AnnotationsTooltipProps,
} from '../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';
import { DEFAULT_TOOLTIP_HIDDEN } from '../constants.js';

/**
 * Populates missing tooltip props with defaults and remaps the slot-level
 * `children` render function to `template` so the rest of the pipeline only
 * deals with one shape. Falls back to the context-supplied template when no
 * slot `children` is provided.
 */
export const populateMissingTooltipProps = (
  tooltipProps: AnnotationsTooltipProps,
  contextConfig?: AnnotationsTooltipProps | AnnotationsTooltipConfig,
): AnnotationsTooltipConfig => {
  const { children, ...restProps } = tooltipProps;

  const contextTemplate =
    (contextConfig as AnnotationsTooltipConfig | undefined)?.template ??
    (contextConfig as AnnotationsTooltipProps | undefined)?.children;

  const config = {
    hidden: contextConfig?.hidden ?? DEFAULT_TOOLTIP_HIDDEN,
  };

  return {
    ...config,
    ...restProps,
    template: children ?? contextTemplate,
  };
};
